<template>
  <div class="bg-nav">
    <!-- NAVBAR -->
    <div>
      <Navbar />
    </div>
    <template v-if="productViews && favorites">
      <div class="bg-products-cot h-auto mb-12" style="height: auto !important">
        <div class="container">
          <!-- CATALOGUE -->
          <div class="container mx-auto my-12">
            <div class="mb-12">
              <h1 class="font-crimson_pro text-3xl font-bold text-theme-9">
                Mis favoritos
              </h1>
            </div>
            <div class="col-span-4">
              <div class="grid grid-cols-2 md:grid-cols-4 gap-4">
                <div
                  class="b-cot-card min-h-[288px] p-4 sm:max-w-[192px] md:max-w-[296px] w-full cursor-pointer"
                  style="background-color: #f4f4f45c"
                  v-for="favorite in favorites"
                  :key="favorite.id"
                  @click="goToProduct(favorite.id)"
                  :title="favorite.name"
                >
                  <div class="grid grid-cols-4 gap-4">
                    <div class="col-span-3">
                      <h1 class="text-theme-9 font-poppins font-medium truncate">
                        {{ favorite.name }}
                      </h1>
                    </div>
                    <div>
                      <span
                        ><heartIcon
                          class="text-theme-9 font-poppins font-medium fill-current"
                      /></span>
                    </div>
                  </div>
                  <div class="bg-white md:w-44 md:h-40 mx-auto my-4">
                    <img
                      class="object-contain h-36 rounded-xl mx-auto"
                      alt="Imagen del producto"
                      :src="getProductImage(favorite)"
                      crossorigin="anonymous"
                    />
                  </div>
                  <div class="grid grid-cols-2 gap-4">
                    <div class="text-xs font-poppins">
                      Mínimo
                      {{
                        favorite?.customizations?.length
                          ? favorite.customizations
                              .map((c) => c.sale_volume)
                              .sort(
                                (a, b) => a.minimum_units - b.minimum_units
                              )[0]
                              .minimum_units.toLocaleString('es-Mx')
                          : 0
                      }}
                      pzas
                    </div>
                    <div class="text-xs font-poppins">
                      Desde
                      {{
                        formatter.format(
                          favorite?.customizations?.sort(
                            (a, b) => a.base_price - b.base_price
                          )[0]?.base_price || 0
                        )
                      }}
                      MXN
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="container mx-auto my-12">
            <div class="mb-12">
              <h1 class="font-crimson_pro text-3xl font-bold text-theme-9">
                Vistos recientemente
              </h1>
            </div>
            <div class="col-span-4">
              <div class="grid grid-cols-2 md:grid-cols-4 gap-4">
                <div
                  class="b-cot-card min-h-[288px] p-4 sm:max-w-[192px] md:max-w-[296px] w-full cursor-pointer"
                  style="background-color: #f4f4f45c"
                  v-for="productData in productViews"
                  :key="productData.id"
                  @click="goToProduct(productData.product.id)"
                  :title="productData.product?.name"
                >
                  <div class="grid grid-cols-4 gap-4">
                    <div class="col-span-3">
                      <h1 class="text-theme-9 font-poppins font-medium truncate">
                        {{ productData.product?.name }}
                      </h1>
                    </div>
                    <div class="">
                      <span
                        ><heartIcon
                          :class="{
                            'text-transparent':
                              !productData?.product?.users_favorite?.length,
                            'text-theme-9':
                              productData?.product?.users_favorite?.length
                          }"
                          class="font-poppins font-medium fill-current"
                          :style="{
                            stroke: !productData?.product?.users_favorite
                              ?.length
                              ? '#a13122'
                              : 'currentColor'
                          }"
                      /></span>
                    </div>
                  </div>
                  <div
                    class="md:w-44 md:h-40 mx-auto my-4"
                    style="background: #ffffff7a; border-radius: 24px"
                  >
                    <img
                      class="object-contain h-36 rounded-xl mx-auto"
                      alt="Imagen del producto"
                      :src="getProductImage(productData.product)"
                      crossorigin="anonymous"
                    />
                  </div>
                  <div class="grid grid-cols-2 gap-4">
                    <div class="text-xs font-poppins">
                      Mínimo
                      {{
                        productData.product?.customizations?.length
                          ? productData.product.customizations
                              .map((c) => c.sale_volume)
                              .sort(
                                (a, b) => a.minimum_units - b.minimum_units
                              )[0]
                              .minimum_units.toLocaleString('es-Mx')
                          : 0
                      }}
                      pzas
                    </div>
                    <div class="text-xs font-poppins">
                      Desde
                      {{
                        formatter.format(
                          productData.product?.customizations?.sort(
                            (a, b) => a.base_price - b.base_price
                          )[0]?.base_price || 0
                        )
                      }}
                      MXN
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <Footer />
      </div>
    </template>
  </div>
</template>

<script>
import Navbar from '@/components/navbar/Main.vue'
import Footer from '@/components/footer/Main.vue'
import { cleanSession, getFirstErrorMessage, formatter } from '@/utils/tools'

export default {
  components: {
    Navbar,
    Footer
  },
  data() {
    return {
      productViews: undefined,
      favorites: undefined,
      formatter: formatter
    }
  },
  async beforeMount() {
    this.$store.commit('main/setShowSpinner', true)
    await Promise.all([this.getFavorites(), this.getProductViews()])
    this.$store.commit('main/setShowSpinner', false)
  },
  methods: {
    async getFavorites() {
      try {
        const response = await this.axios.get(
          'sales-operator/favorite-products/all',
          {
            headers: {
              Authorization: `Bearer ${this.$store.state.auth.token}`
            }
          }
        )
        this.favorites = response.data.favorite_products || []
      } catch (error) {
        if (error?.response?.status === 401) {
          this.$toast.error('Su sesión ha expirado', {
            position: 'top'
          })
          return cleanSession(this.$store, this.$router)
        }
        this.$toast.error(getFirstErrorMessage(error), {
          position: 'top'
        })
      }
    },
    async getProductViews() {
      try {
        const response = await this.axios.get(
          'sales-operator/product-views/all',
          {
            headers: {
              Authorization: `Bearer ${this.$store.state.auth.token}`
            }
          }
        )
        this.productViews = response.data.products_views || []
      } catch (error) {
        if (error?.response?.status === 401) {
          this.$toast.error('Su sesión ha expirado', {
            position: 'top'
          })
          return cleanSession(this.$store, this.$router)
        }
        this.$toast.error(getFirstErrorMessage(error), {
          position: 'top'
        })
      }
    },
    getProductImage(product) {
      return Array.isArray(product?.image) && product?.image?.length
        ? product.image[0]
        : require(product?.sku !== 'COTESPI001'
            ? '@/assets/images/product.svg'
            : '@/assets/images/COTESPI001.svg')
    },
    goToProduct(productId) {
      this.$router.push({ name: 'products', params: { id: productId } })
    }
  }
}
</script>

<style scoped>
.bg-nav {
  background: url('@/assets/images/COT-bg/img-slider-nav.svg');
  background-repeat: no-repeat;
  background-position: initial;
  backface-visibility: hidden;
  height: 480px;
  width: auto;
}

.bg-banner-2 {
  background: url('@/assets/images/COT-bg/img-banner2.svg');
  background-repeat: no-repeat;
  background-position: initial;
  backface-visibility: hidden;
  height: 600px;
  width: auto;
}

.bg-geometria {
  background: url('@/assets/images/COT-bg/img-geometria.svg');
  background-repeat: no-repeat;
  background-position: center;
  backface-visibility: hidden;
  height: 600px;
  width: auto;
}

.bg-cat-bg {
  background: url('@/assets/images/COT-bg/img-categorias.svg');
  background-repeat: no-repeat;
  background-position: center;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  height: 60px;
  width: auto;
  padding-top: 2px;
}

.bg-banner {
  background: linear-gradient(
    111.68deg,
    rgba(255, 255, 255, 0.29) 7.59%,
    rgba(255, 255, 255, 0.39) 102.04%
  );
  backdrop-filter: blur(8px) brightness(100%);
  border: 3px solid rgba(255, 255, 255, 0.28);
}

.backtest {
  background: url('@/assets/images/COT-bg/img-banner2.svg');
  background-position: bottom;
  background-repeat: no-repeat;
  background-size: cover;
}

.bg-banner-cot {
  background: url('@/assets/images/COT-bg/img-banner2.svg');
  background-repeat: no-repeat;
  background-position: center;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  height: 198px;
  width: auto;
  padding-top: 0px;
  margin-bottom: 18rem;
}

.bg-banner-cot-res {
  background: url('@/assets/images/COT-bg/img-banner2.svg');
  background-repeat: no-repeat;
  background-position: center;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  height: 445px;
  width: auto;
  padding-top: 0px;
}

.bg-products-cot {
  background: url('@/assets/images/COT-bg/img-products.svg');
  background-repeat: no-repeat;
  background-position: inherit;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  height: 230px;
  width: auto;
  padding-top: 2px;
}

.bg-help {
  background: url('@/assets/images/COT-bg/img-help.svg');
  background-repeat: no-repeat;
  background-position: right;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  height: 350px;
  width: auto;
  padding-top: 2px;
}

.btn-deg {
  background: linear-gradient(89.75deg, #e85c04 0.17%, #faa306 99.78%);
  transition: 0.3s;
  outline: 1px solid transparent;
  width: 200px;
  font-weight: 600;
}

.b-cot-card {
  background-image: radial-gradient(
      circle at 100% 100%,
      transparent 18px,
      #ffffff 18px,
      #ffffff 21px,
      transparent 21px
    ),
    linear-gradient(to right, #ffffff, #ffffff),
    radial-gradient(
      circle at 0% 100%,
      transparent 18px,
      #ffffff 18px,
      #ffffff 21px,
      transparent 21px
    ),
    linear-gradient(to bottom, #ffffff, #f6f6e0),
    radial-gradient(
      circle at 0% 0%,
      transparent 18px,
      #ffffff21 18px,
      #ffffff21 21px,
      transparent 21px
    ),
    linear-gradient(to left, #ffffff21, #ffffff21),
    radial-gradient(
      circle at 100% 0%,
      transparent 18px,
      #ffffff21 18px,
      #ffffff21 21px,
      transparent 17px
    ),
    linear-gradient(to top, #ffffff21, #ffffff);
  background-size: 21px 21px, calc(100% - 42px) 3px, 21px 21px,
    3px calc(100% - 42px);
  background-position: top left, top center, top right, center right,
    bottom right, bottom center, bottom left, center left;
  background-repeat: no-repeat;
  border-radius: 24px;
}

.bg-card {
  background: #ffffff21;
  border-radius: 24px;
}

.eventos {
  background-image: url('@/assets/images/COT-img/eventos/fiestas-1.svg');
}

.flip-card {
  background-color: transparent;
  perspective: 1000px;
}

.flip-card-inner {
  position: relative;
  width: 100%;
  height: 100%;
  text-align: center;
  transition: transform 0.6s;
  transform-style: preserve-3d;
}

.flip-card:hover .flip-card-inner {
  transform: rotateY(180deg);
}

.flip-card-front,
.flip-card-back {
  position: absolute;
  width: 100%;
  height: 100%;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}

.flip-card-front {
  background: linear-gradient(
    111.68deg,
    rgba(255, 255, 255, 0.29) 7.59%,
    rgba(255, 255, 255, 0.39) 102.04%
  );
  border: 3px solid rgba(255, 255, 255, 0.28);
  backdrop-filter: blur(22px);
  /* Note: backdrop-filter has minimal browser support */
  border-radius: 20px;
}

.flip-card-back {
  background: linear-gradient(
    111.68deg,
    rgba(255, 255, 255, 0.29) 7.59%,
    rgba(255, 255, 255, 0.39) 102.04%
  );
  border: 3px solid rgba(255, 255, 255, 0.28);
  backdrop-filter: blur(22px);
  border-radius: 20px;
  transform: rotateY(180deg);
}

.brandin-card {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  font-size: 16px;
}

/* SEARCH CONTROL CSS */
.form-control {
  border-color: transparent;
}

.input-group > .form-control:focus {
  border-color: transparent;
  box-shadow: inset 0 0 0 1px transparent;
}
.btn-link:hover {
  background-color: rgba(0, 0, 0, 0.05);
}
.btn-link:active,
.btn-link.active {
  background-color: rgba(0, 0, 0, 0.05);
}
.btn-link:focus,
.btn-link.focus {
  background-color: rgba(0, 0, 0, 0.05);
}
.btn-link:active:focus,
.btn-link.active:focus {
  background-color: rgba(0, 0, 0, 0.05);
}

.i-search {
  border-radius: 6px 0px 0px 6px !important;
  background: rgb(241, 241, 241) !important;
  border-color: #cacaca !important;
  border-bottom-width: 1px !important;
  border-style: solid none solid solid !important;
  border-top-width: 1px !important;
  border-left-width: 1px !important;
  border-right-width: initial !important;
}
.i-search-form {
  background: rgb(241, 241, 241);
  border-color: #cacaca;
  border-bottom-width: 1px;
  border-style: solid solid solid none;
  border-top-width: 1px;
  border-right-width: 1px;
  border-left-width: initial;
  border-radius: 0px 6px 6px 0px;
  box-shadow: 0 0 0;
}
</style>
